import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StripHtmlPipe } from '../../../pipes/strip-html.pipe'

@Component({
    selector: 'case-text-yield',
    templateUrl: './text-yield.component.html',
    styleUrls: ['./text-yield.component.scss'],
    standalone: true,
    imports: [CommonModule, StripHtmlPipe]
})
export class TextYieldComponent {
  @Input() text: string
  @Input() secondText: string
}
